import source from './interface-messages.json';
import {message, normalizeLanguage} from './index';
import {currentLanguage} from './runtime';

// Only authored interface copy. Patient text and card content never pass here.
const entries = new Map(source.entries.map(entry => [entry.id, entry]));
export function interfaceText(id, language = currentLanguage(), vars) {
  const entry = entries.get(id);
  if (!entry) throw new Error(`Unknown interface text: ${id}`);
  const lang = normalizeLanguage(language);
  return message(id, lang, lang === 'de' ? entry.de : entry.en, vars);
}
